import {
  Container,
  CategoryNameAndChevronWrapper,
  RowGap,
} from './CategoryListSkeleton.styled';
import { Skeleton } from '@mui/material';

interface ICategoryListSkeletonProps {
  index: number;
  opacityCoefficient?: number;
  withoutLine: boolean;
}

const CategoryListSkeleton = ({
  index,
  opacityCoefficient = 0.2,
  withoutLine,
}: ICategoryListSkeletonProps) => {
  return (
    <Container
      withoutLine={withoutLine}
      opacityCoefficient={opacityCoefficient}
      opacityIndex={index}
    >
      <CategoryNameAndChevronWrapper>
        <RowGap>
          <Skeleton width="200rem" height={'30rem'} animation="wave" />
        </RowGap>
      </CategoryNameAndChevronWrapper>
    </Container>
  );
};

export default CategoryListSkeleton;
